"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchetypeResolver = void 0;
var stylable_shorthands_1 = require("./stylable-shorthands");
var general_utils_1 = require("./utils/general-utils");
var DEFAULT_ARCHETYPE_NAME = 'default';
var ArchetypeResolver = /** @class */ (function () {
    function ArchetypeResolver(sheetPath, archetypeList, stylableDriver, globalFilterFunction) {
        if (globalFilterFunction === void 0) { globalFilterFunction = function () { return true; }; }
        this.sheetPath = sheetPath;
        this.archetypeList = archetypeList;
        this.stylableDriver = stylableDriver;
        this.globalFilterFunction = globalFilterFunction;
        var stylesheet = stylableDriver.getStylesheet(sheetPath);
        if (!stylesheet) {
            throw new Error("stylesheet " + stylesheet + " not found");
        }
        else {
            this.stylesheet = stylesheet;
        }
    }
    ArchetypeResolver.prototype.getPropNames = function (archetypeName) {
        var propList = [];
        var source = this.archetypeList[archetypeName];
        if (source === undefined) {
            source = this.archetypeList[DEFAULT_ARCHETYPE_NAME];
        }
        if (source) {
            source.props.forEach(function (prop) {
                if (Array.isArray(prop)) {
                    propList = propList.concat(prop);
                }
                else {
                    propList.push(prop);
                }
            });
        }
        return propList;
    };
    ArchetypeResolver.prototype.getPrefferedSectionForSelector = function (selector) {
        var deepestExtendName = this.getArchetypeId(selector);
        if (deepestExtendName && this.archetypeList[deepestExtendName]) {
            return this.archetypeList[deepestExtendName].preferred;
        }
        return undefined;
    };
    ArchetypeResolver.prototype.getPropNamesFromSelector = function (selector) {
        var retVal = [];
        var deepestExtendName = this.getArchetypeId(selector);
        if (deepestExtendName) {
            retVal = this.getPropNames(deepestExtendName);
        }
        var usedProps = this.stylesheet.collectSelectorUsedProps(selector);
        var shorthands = new stylable_shorthands_1.StylableShorthands(this.stylesheet.evalDeclarationValue.bind(this.stylesheet));
        var expandedUsedProps = usedProps.reduce(function (currentExpandedUsedProps, prop) {
            return currentExpandedUsedProps.concat(prop).concat(shorthands.getShorthandProps(prop));
        }, []);
        retVal = retVal.concat(expandedUsedProps).filter(this.globalFilterFunction);
        retVal = general_utils_1.removeDuplicates(retVal);
        var selectorArchetype = this.archetypeList[deepestExtendName];
        if (selectorArchetype && selectorArchetype.propBlacklist) {
            retVal = retVal.filter(function (prop) {
                return !selectorArchetype.propBlacklist.some(function (blacklistedPropQuery) { return !!prop.match(blacklistedPropQuery); });
            });
        }
        return retVal;
    };
    ArchetypeResolver.prototype.getBlockVariantsForElement = function (selector, sectionId) {
        var deepestExtendName = this.getArchetypeId(selector);
        if (deepestExtendName &&
            this.archetypeList[deepestExtendName] &&
            this.archetypeList[deepestExtendName].blockVariantSets) {
            return this.archetypeList[deepestExtendName].blockVariantSets[sectionId];
        }
        return undefined;
    };
    ArchetypeResolver.prototype.getArchetypeId = function (selector) {
        return this.stylableDriver.getArchetypeName(this.sheetPath, selector) || DEFAULT_ARCHETYPE_NAME;
    };
    return ArchetypeResolver;
}());
exports.ArchetypeResolver = ArchetypeResolver;
//# sourceMappingURL=archetype-resolver.js.map